module.exports = __webpack_public_path__ + "static/media/es-flag.2f7f43b9.svg";